import COISWizardConfig from '@repo/app-assets/COISWizardConfig'
import FormEvoFormMappingWizardConfig from '@repo/app-assets/FormEvoFormMappingWizardConfig'
import NewClientWizardConfig from '@repo/app-assets/NewClientWizardConfig'
import NewMatterNotificationApprovalConfig from '@repo/app-assets/NewMatterNotificationApprovalConfig'
import NewMatterWizardConfig from '@repo/app-assets/NewMatterWizardConfig'
import NewPerfectPortalCaseTypeWizardConfig from '@repo/app-assets/NewPerfectPortalCaseTypeWizardConfig'
import ThirdPartyFormWizardConfig from '@repo/app-assets/ThirdPartyFormWizardConfig'
import DocumentBundleWizardConfig from '@repo/app-assets/DocumentBundleWizardConfig'
export default {
  'COIS-NewClient-NewMatter': [...COISWizardConfig, ...NewClientWizardConfig, ...NewMatterWizardConfig],
  'COIS-ExistingClient-NewMatter': [...COISWizardConfig, ...NewMatterWizardConfig],
  'COIS-ExistingClient-ExistingMatter': [...COISWizardConfig],
  'NewClient-NewMatter': [...NewClientWizardConfig, ...NewMatterWizardConfig],
  'ExistingClient-NewMatter': [...NewMatterWizardConfig],
  'NewMatter-NotificationApproval': [...NewMatterNotificationApprovalConfig, ...NewMatterWizardConfig],
  'NewMatter-NewClient-NotificationApproval': [
    ...NewMatterNotificationApprovalConfig,
    ...NewClientWizardConfig,
    ...NewMatterWizardConfig
  ],
  'COIS-NewMatter-NotificationApproval': [
    ...NewMatterNotificationApprovalConfig,
    ...COISWizardConfig,
    ...NewMatterWizardConfig
  ],
  'COIS-NewMatter-NewClient-NotificationApproval': [
    ...NewMatterNotificationApprovalConfig,
    ...COISWizardConfig,
    ...NewClientWizardConfig,
    ...NewMatterWizardConfig
  ],
  'PerfectPortal-CaseType': [...NewPerfectPortalCaseTypeWizardConfig],
  ThirdPartyForm: [...ThirdPartyFormWizardConfig],
  DocumentBundle: [...DocumentBundleWizardConfig],
  'FormEvo-FormMapping': [...FormEvoFormMappingWizardConfig]
}